export default __webpack_public_path__ + "static/media/agent1.18597c96.png";